<!-- Grid View -->
<div class="card coupon-grid-outer" (click)="showCouponMetadataModal(couponData, coupon_metadata_modal)" *ngIf="displayType == 'grid'">
    <div class="card-body text-center cursor-pointer">
      <div class="title text-muted mt-1 mb-2" [title]="couponData.description" *ngIf="!couponData.metadata_title">{{ couponData.description }}</div>
      <div class="title text-muted mt-1 mb-2" [title]="couponData.metadata_title" *ngIf="couponData.metadata_title">{{ couponData.metadata_title }}</div>
  
      <img class="img mt-1 mb-2" [src]="couponData.metadata_mobile_image_url" alt="..." *ngIf="couponData.metadata_status == '1'">

      <p class="text-danger">Circulation - {{ couponData.total_circulation }}</p>
  
      <div class="row">
        <div class="col-12">
          <span class="coupon-date text-muted float-start pt-1">
            <i-bs class="text-info" name="calendarCheck" title="Coupon Date"></i-bs>
            {{ couponData.redemption_start_time | date : 'MMM d, y' : 'UTC' }} - {{ couponData.redemption_end_time | date : 'MMM d, y' : 'UTC' }}
          </span>
  
          <span class="float-end" [ngbPopover]="couponPopContent" triggers="mouseenter" (mouseleave)="p.close()" #p="ngbPopover">
            <i-bs class="text-info cursor-pointer" name="infoCircle"></i-bs>
            <span class="status text-muted">&nbsp;Details</span>
          </span>
        </div>
      </div>
    </div>
</div>
  
<!-- List View -->
<div class="coupon-list-outer bg-white" *ngIf="displayType == 'list'">
    <!-- Header -->
    <div class="row header-row border-bottom m-1 pt-4">
        <div class="col-1 title text-muted">Image</div>
        <div class="col-2 title text-muted">Title</div>
        <div class="col-2 title text-muted">Base GS1</div>
        <div class="col-2 title text-muted">Products</div>
        <div class="col-1 title text-muted">Start Date</div>
        <div class="col-1 title text-muted">End Date</div>
        <div class="col-1 title text-muted">Circulation</div>
        <div class="col-2 title text-muted">Retailers</div>
    </div>
  
    <!-- Data -->
    <div class="row data-row border-bottom border-light m-1 cursor-pointer" *ngFor="let coupon of couponListData" (click)="showCouponMetadataModal(coupon, coupon_metadata_modal)">
      <div class="col-1">
          <img class="img cursor-pointer" [src]="coupon.metadata_mobile_image_url" alt="..." *ngIf="coupon.metadata_mobile_image_url">
      </div>
      <div class="col-2 value text-muted">
        <span *ngIf="!coupon.metadata_title">{{ coupon.description }}</span>
        <span *ngIf="coupon.metadata_title">{{ coupon.metadata_title }}</span>
      </div>
      <div class="col-2 value text-muted">
        {{ coupon.base_gs1 }}
      </div>
      <div class="col-2 value text-muted">
        {{ formatComa(coupon.primary_purchase_gtins) }}
      </div>
      <div class="col-1 value text-muted">
        {{ coupon.redemption_start_time | date : 'MMM d, y' : 'UTC' }}
      </div>
      <div class="col-1 value text-muted">
        {{ coupon.redemption_end_time | date : 'MMM d, y' : 'UTC' }}
      </div>
      <div class="col-1 value text-muted">
        {{ coupon.total_circulation }}
      </div>
      <div class="col-2 value text-muted">
        {{ formatComa(coupon.assigned_retailers) }}
      </div>
    </div>
</div>
  
  <!-- Coupon Details Popover-->
  <ng-template #couponPopContent>
    <div class="container popover-outer p-0">
      <div class="row">
        <div class="col-12">
          <div class="text-muted fw-bold">Base GS1 : <span class="qty-per-transaction text-muted fw-normal">{{ couponData.base_gs1 }}</span></div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="text-muted fw-bold">Products</div>
          <span class="products text-muted">{{ formatComa(couponData.primary_purchase_gtins) }}</span>
        </div>
      </div>
      <div class="row mt-2" *ngIf="couponData.assigned_retailers">
        <div class="col-12">
          <div class="text-muted fw-bold">Assigned Retailers</div>
          <span class="products text-muted">{{ formatComa(couponData.assigned_retailers) }}</span>
        </div>
      </div>
      <div class="row mt-2" *ngIf="couponData.metadata_terms">
        <div class="col-12">
          <div class="text-muted fw-bold">Terms</div>
          <span class="products text-muted">{{ couponData.metadata_terms }}</span>
        </div>
      </div>
    </div>
  </ng-template>
  
<!-- Coupon Metadata Modal -->
<ng-template #coupon_metadata_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">{{ couponModalData.description }}</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideCouponMetadataModal()"></i-bs>
  </div>

  <div class="modal-body coupon-metadata-outer">
      <!-- Category -->
      <div class="row mt-1">
        <div class="col-12">
          <span class="text-muted fw-bold">
            Category
            <i-bs
            name="infoCircle"
            class="text-primary"
            tooltip="Select the category for the coupon."
            placement="top"></i-bs>
          </span>

          <button class="btn btn-outline-secondary btn-sm float-end" (click)="showMasterFormModal('category', 'Categories', master_form_modal)">Add</button>
        </div>
        <div class="col-12 mt-2">
          <ng-multiselect-dropdown 
            [disabled]="categorySelectionDisabled"
            [placeholder]="'Select'"
            [settings]="categorySelectionSettings"
            [data]="categories"
            [(ngModel)]="couponMetadataCategories"
            (onDeSelect)="onCategoryDeSelect($event)">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <!-- Manufacturer & Brand -->
      <div class="row mt-4">
        <div class="col-6">
          <span class="text-muted fw-bold">
            Manufacturer
            <i-bs
            name="infoCircle"
            class="text-primary"
            tooltip="Select the manufacturer for the coupon."
            placement="top"></i-bs>
          </span>

          <button class="btn btn-outline-secondary btn-sm float-end" (click)="showMasterFormModal('manufacturer', 'Manufacturers', master_form_modal)">Add</button>
        </div>
        <div class="col-6">
          <span class="text-muted fw-bold">
            Brand
            <i-bs
            name="infoCircle"
            class="text-primary"
            tooltip="Select the brand for the coupon."
            placement="top"></i-bs>
          </span>

          <button class="btn btn-outline-secondary btn-sm float-end" (click)="showMasterFormModal('brand', 'Brands', master_form_modal)">Add</button>
        </div>

        <div class="col-6 mt-2">
          <select class="form-select text-muted" 
            placeholder="Select"
            [(ngModel)]="couponMetadataManufacturer"
            [disabled]="manufacturersLoading === true"
            (change)="onManufacturerChange($event)">
            <option *ngFor="let manufacturer of manufacturers" [ngValue]="manufacturer">{{ manufacturer.mfg_name }}</option>
          </select>
        </div>
        <div class="col-6 mt-2">
          <select class="form-select text-muted" 
            placeholder="Select"
            [(ngModel)]="couponMetadataBrand"
            [disabled]="brandsLoading === true">
            <option *ngFor="let brand of brands" [ngValue]="brand">{{ brand.brand_name }}</option>
          </select>
        </div>
      </div>

      <!-- Coupon Title -->
      <div class="row mt-4">
          <div class="col-12">
            <span class="text-muted fw-bold">
              Title
              <i-bs
              name="infoCircle"
              class="text-primary"
              tooltip="Add title of coupon. Max no of characters are 100."
              placement="top"></i-bs>
            </span>
    
            <input type="text" class="form-control mt-2" id="coupon_title" maxlength="100" placeholder="E.g. Save $1 on Downy Liquid Fabric Conditioner" [(ngModel)]="couponMetadataTitle">
          </div>
      </div>

      <!-- Coupon Description -->
      <div class="row mt-4">
          <div class="col-12">
          <span class="text-muted fw-bold">
              Description
              <i-bs
              name="infoCircle"
              class="text-primary"
              tooltip="Add description of coupon. Max no of characters are 2500."
              placement="top"></i-bs>
          </span>
  
          <textarea class="form-control mt-2" id="coupon_description" maxlength="2500" rows="5" placeholder="E.g. Terms & Conditions..." [(ngModel)]="couponMetadataDescription"></textarea>
          </div>
      </div>
  
      <!-- Coupon Image -->
      <div class="row mt-4">
          <div class="col-12">
            <span class="text-muted fw-bold">
              Image
              <i-bs
                name="infoCircle"
                class="text-primary"
                tooltip="Add image for coupon. Max file size is 50 Kb. File types supported are png & jpg."
                placement="top">
              </i-bs>
            </span>
          </div>

          <div class="col-6 mt-2">
              <ngx-dropzone [multiple]="false" (change)="onImageSelect($event)">
              <ngx-dropzone-label>Click or Drag & Drop your coupon image here <br> Files supported - png & jpeg <br> Max file size 50 Kb</ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let imageFile of couponImageFiles" [removable]="true" (removed)="onImageRemove(imageFile)">
                  <ngx-dropzone-label>{{ imageFile.name }} ({{ imageFile.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
              </ngx-dropzone>
          </div>
          <div class="col-6 d-flex justify-content-center mt-2" *ngIf="couponMetadataImageFilesSelected.length == 1">
              <img class="img-preview" [src]="couponMetadataImageFilesSelected[0].file_base64" *ngIf="couponMetadataImageFilesSelected[0].file_base64">
              <img class="img-preview" [src]="couponMetadataImageFilesSelected[0].file_s3" *ngIf="couponMetadataImageFilesSelected[0].file_s3 && !couponMetadataImageFilesSelected[0].file_base64">
          </div>
      </div>
  </div>

  <div class="modal-footer" *ngIf="couponModalData.metadata_status == '0'">
    <button type="button" class="btn btn-secondary text-white fw-bold" title="Save Metadata" (click)="onSaveMetaData()">
      Save
      <div class="spinner-border spinner-border-sm text-light" role="status" *ngIf="savingMetadata"></div>
    </button>
  </div>
</ng-template>
  
<!-- Master form Modal -->
<ng-template #master_form_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">{{ masterFormModalData.title }}</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideMasterFormModal()"></i-bs>
  </div>

  <div class="modal-body">
    <app-manage-category module='ADMIN' *ngIf="masterFormModalData.mode == 'category'" (actions)="masterFormActions('category', $event)"></app-manage-category>

    <app-manage-manufacturer module='ADMIN' *ngIf="masterFormModalData.mode == 'manufacturer'" (actions)="masterFormActions('manufacturer', $event)"></app-manage-manufacturer>

    <app-manage-brand module='ADMIN' *ngIf="masterFormModalData.mode == 'brand'" (actions)="masterFormActions('brand', $event)"></app-manage-brand>
  </div>
</ng-template>